module.exports = __webpack_public_path__ + "img/Dantam Makeover 25.0f99bc85.jpg";